import http from './http'

export function listMacros() {
  return http.get('/macros')
}

export function getMacro(id) {
  return http.get(`/macros/${id}`)
}

export function createMacro(payload) {
  return http.post('/macros', payload)
}

export function updateMacro(id, payload) {
  return http.put(`/macros/${id}`, payload)
}

export function deleteMacro(id) {
  return http.delete(`/macros/${id}`)
}
